import { BrandRankingProvider } from 'contexts/BrandRankingContext'

import { useZaiChatMobilePageModel } from './zai-chat-mobile-page.model'
import { ZaiChatMobilePageView } from './zai-chat-mobile-page.view'

function ZaiChatMobilePage() {
  const zaiChatMobilePageModel = useZaiChatMobilePageModel()
  return <ZaiChatMobilePageView {...zaiChatMobilePageModel} />
}

export function ZaiChatMobilePageWrapper() {
  return (
    <BrandRankingProvider>
      <ZaiChatMobilePage />
    </BrandRankingProvider>
  )
}
